import React from 'react';
import Card from '../../../shared/components/Card';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import useTranslation from '../../../shared/hooks/useTranslation';

const ServicesSection: React.FC = () => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  const services = [
    {
      icon: '/images/icon-sp.png',
      titleKey: 'services.sp.title',
      descriptionKey: 'services.sp.description',
      color: 'red',
      items: ['VSAV, FPT, EPA, VLM', 'Grades et compétences', 'Interventions incendie', 'Secours à personnes'],
    },
    {
      icon: '/images/icon-samu.png',
      titleKey: 'services.samu.title',
      descriptionKey: 'services.samu.description',
      color: 'blue',
      items: ['Centres de réception', 'Ambulances SMUR', 'Médecins régulateurs', 'Urgences médicales'],
    },
    {
      icon: '/images/icons8-homme-debout-50.png',
      titleKey: 'services.fdo.title',
      descriptionKey: 'services.fdo.description',
      color: 'indigo',
      items: ['Commissariats', 'Brigades de gendarmerie', 'Interventions sécuritaires', 'Coordination 17'],
    },
    {
      icon: '/images/icon-cta.png',
      titleKey: 'services.cta.title',
      descriptionKey: 'services.cta.description',
      color: 'orange',
      items: ['Réception 18/112', 'Coordination CODIS', 'Déclenchement moyens', 'Suivi interventions'],
    },
  ];

  const colorClasses = {
    red: 'from-red-600 to-red-800 border-red-600/50 hover:border-red-400',
    blue: 'from-blue-600 to-blue-800 border-blue-600/50 hover:border-blue-400',
    indigo: 'from-indigo-600 to-indigo-800 border-indigo-600/50 hover:border-indigo-400',
    orange: 'from-orange-600 to-orange-800 border-orange-600/50 hover:border-orange-400',
  };

  return (
    <section className="py-20 relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-6">
            <span className="text-gradient">{t('services.title')}</span>
          </h2>
          <p className="text-2xl text-gray-400 max-w-4xl mx-auto leading-relaxed">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              hover 
              glow 
              className={`p-8 bg-gradient-to-br ${colorClasses[service.color as keyof typeof colorClasses]}`}
            >
              <div className="text-center">
                <div className={`w-24 h-24 bg-gradient-to-br ${colorClasses[service.color as keyof typeof colorClasses].split(' ')[0]} ${colorClasses[service.color as keyof typeof colorClasses].split(' ')[1]} rounded-3xl flex items-center justify-center mx-auto mb-6 transition-transform duration-300 hover:scale-110`}>
                  <img src={service.icon} alt={t(service.titleKey)} className="w-14 h-14" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{t(service.titleKey)}</h3>
                <p className="text-gray-300 mb-6 text-lg">{t(service.descriptionKey)}</p>
                <ul className="text-sm text-gray-400 space-y-2 text-left">
                  {service.items.map((item, i) => (
                    <li key={i}>• {item}</li>
                  ))}
                </ul>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;

